module.exports = __webpack_public_path__ + "img/checked.1a088cb2.svg";